/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListTicketMessagesGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type ListTicketMessagesRequest = {
  accountID: string;
  ticketID: string;
};

export type ListTicketMessagesResponse = {
  headers: { [k: string]: Array<string> };
  result: Array<components.TicketMessage>;
};

/** @internal */
export const ListTicketMessagesGlobals$inboundSchema: z.ZodType<
  ListTicketMessagesGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type ListTicketMessagesGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const ListTicketMessagesGlobals$outboundSchema: z.ZodType<
  ListTicketMessagesGlobals$Outbound,
  z.ZodTypeDef,
  ListTicketMessagesGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function listTicketMessagesGlobalsToJSON(
  listTicketMessagesGlobals: ListTicketMessagesGlobals,
): string {
  return JSON.stringify(
    ListTicketMessagesGlobals$outboundSchema.parse(listTicketMessagesGlobals),
  );
}
export function listTicketMessagesGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<ListTicketMessagesGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListTicketMessagesGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListTicketMessagesGlobals' from JSON`,
  );
}

/** @internal */
export const ListTicketMessagesRequest$inboundSchema: z.ZodType<
  ListTicketMessagesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
  ticketID: z.string(),
});
/** @internal */
export type ListTicketMessagesRequest$Outbound = {
  accountID: string;
  ticketID: string;
};

/** @internal */
export const ListTicketMessagesRequest$outboundSchema: z.ZodType<
  ListTicketMessagesRequest$Outbound,
  z.ZodTypeDef,
  ListTicketMessagesRequest
> = z.object({
  accountID: z.string(),
  ticketID: z.string(),
});

export function listTicketMessagesRequestToJSON(
  listTicketMessagesRequest: ListTicketMessagesRequest,
): string {
  return JSON.stringify(
    ListTicketMessagesRequest$outboundSchema.parse(listTicketMessagesRequest),
  );
}
export function listTicketMessagesRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListTicketMessagesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListTicketMessagesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListTicketMessagesRequest' from JSON`,
  );
}

/** @internal */
export const ListTicketMessagesResponse$inboundSchema: z.ZodType<
  ListTicketMessagesResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: z.array(components.TicketMessage$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type ListTicketMessagesResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: Array<components.TicketMessage$Outbound>;
};

/** @internal */
export const ListTicketMessagesResponse$outboundSchema: z.ZodType<
  ListTicketMessagesResponse$Outbound,
  z.ZodTypeDef,
  ListTicketMessagesResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: z.array(components.TicketMessage$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function listTicketMessagesResponseToJSON(
  listTicketMessagesResponse: ListTicketMessagesResponse,
): string {
  return JSON.stringify(
    ListTicketMessagesResponse$outboundSchema.parse(listTicketMessagesResponse),
  );
}
export function listTicketMessagesResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListTicketMessagesResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListTicketMessagesResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListTicketMessagesResponse' from JSON`,
  );
}
